import React, { useState } from "react";
import { useLogin } from "@hooks";

export interface ILoginForm {
  username: string;
  password: string;
}

export const LoginPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { mutate: login } = useLogin<ILoginForm>();

  return (
    <>
      <h1>Sign in</h1>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          login({ username, password });
        }}
      >
        <table>
          <tbody>
            <tr>
              <td>Username:</td>
              <td>
                <input
                  type="text"
                  size={20}
                  autoCorrect="off"
                  spellCheck={false}
                  autoCapitalize="off"
                  autoFocus
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td>Password:</td>
              <td>
                <input
                  type="password"
                  required
                  size={20}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <input type="submit" value="login" />
      </form>
    </>
  );
};
